export const data = {
  Malware: {
    name: 'Malware',
    style: {
      background: 'rgba(18, 112, 244, 0.2)',
      border: '1px solid #1270F4',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#1270F4',
    },
    val: 30,
    date: '8 Mar 2022',
  },
  OsVulnerabilities: {
    name: 'OS Vulnerabilities',
    style: {
      background: 'rgba(97, 171, 237, 0.2)',
      border: '1px solid #61abed',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#61abed',
    },
    val: 30,
    date: '8 Mar 2022',
  },
  DataAtRisk: {
    name: 'Data At Risk',
    style: {
      background: 'rgba(28, 151, 226, 0.2)',
      border: '1px solid #1C97E2',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#1C97E2',
    },
    val: 25,
    date: '5 Apr 2022',
  },
  Authentications: {
    name: 'Authentications',
    style: {
      background: 'rgba(100, 86, 175, 0.2)',
      border: '1px solid #6456AF',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#6456AF',
    },
    val: 15,
    date: '1 Mar 2022',
  },
  IAMMisconfigurations: {
    name: 'IAM Misconfigurations',
    val: 20,
    style: {
      background: 'rgba(144, 55, 174, 0.2)',
      border: '1px solid #9037AE',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#9037AE',
    },
    date: '5 Jan 2022',
  },
  Vulnerabilities: {
    name: 'Vulnerabilities',
    val: 15,
    style: {
      background: 'rgba(157, 45, 175, 0.2)',
      border: '1px solid #9D2DAF',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#9D2DAF',
    },
    date: '8 Aug 2022',
  },
  LateralMovement: {
    name: 'Lateral Movement',
    style: {
      background: 'rgba(247, 149, 79, 0.2)',
      border: '1px solid #F7954F',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#F7954F',
    },
    val: 20,
    date: '23 Jul 2022',
  },
  NeglectedAssets: {
    name: 'Neglected Assets',
    style: {
      background: 'rgba(227, 179, 107, 0.2)',
      border: '1px solid #E3B36B',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#E3B36B',
    },
    val: 15,
    date: '18 Sep 2022',
  },
  thirdPartyRisks: {
    name: 'Third Party Risks',
    style: {
      background: 'rgba(165, 42, 42, 0.2)', // Adjusted to a lighter brown with transparency
      border: '1px solid #A52A2A', // A shade of brown
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: '#A52A2A', // Text color set to brown
    },
    val: 15,
    date: '18 Sep 2022',
  },
  NA: {
    name: 'Neglected Assets',
    style: {
      background: 'lightgrey',
      border: '1px solid navyblue',
      boxSizing: 'border-box',
      borderRadius: '3px',
      color: 'navyblue',
    },
    val: 15,
    date: '18 Sep 2022',
  },
};
